import { render } from "./ActivityIcon.vue?vue&type=template&id=a87af18c"
import script from "./ActivityIcon.vue?vue&type=script&lang=js"
export * from "./ActivityIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__